import axios from "axios";
import { CONSTANTS } from "../../constants/Constants";
import { localStorageHandler } from "../../utils/helpers";

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL || "/api/v1",
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use(
  function (config) {
    const token = localStorageHandler(
      "get",
      CONSTANTS.LOCAL_STORAGE_KEYS.USER_TOKEN_TXT
    );
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  function (error) {
    console.error("Request Error: ", error);
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {    
    console.error("Response Error: ", error.response?.data || error.message);
    if (error.status === 401) {
      localStorageHandler("clear");
      window.location.href = "/";
    } else if (typeof error.response?.data === "string" && error.response?.data === "Network Error" ) {
      alert(error.response?.data)
    } else if (typeof error?.message === "string" && error?.message === "Network Error"){
      alert(error.message)
    }

    return Promise.reject(error);
  }
);

export default api;